import API from 'utils/API'

export const generateSupportSessionCode = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/cms/support-session', payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const verifyPassword = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/passwords/verify', payload).then(
      (response) => {
        const { meta } = response.data
        if (meta.status) {
          resolve()
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
